<div class="col-sm-6">

    <div>
        <p style="text-align: left;
            font: normal normal bold 26px/53px Montserrat;
            letter-spacing: 0px;
            color: #00B09E;
            opacity: 1;">Mantenedor Reglamento General</p>
    </div>

    <div>
        <p class="titulo-card-amarillo">Tipo Subida archivos Reglamento Interno</p>
    
        <table class="table-info">
            <tr class="table-tr-shadow">
                <td>
                    <p class="table-row-title">ESTADO:</p>
                </td>
                <td><p class="table-row-title">{{estadoSubida}}</p></td>
            </tr>
           
        </table>

    </div>

    <br/>
    <br/>

    <div >  
        <p class="titulo-card-amarillo">Cambiar subida Reglamento Interno</p>

           <table>
               <tr>
                   <td>
                       <button type="button" (click)="activar()"  class="btn btn-light btn-send" >CAMBIAR</button>
                   </td>
               </tr>
           </table>
    </div>

    <br/>
    <br/>

    <div *ngIf="parametroSubida === 1">

        <div>
            <p style="text-align: left;
                font: normal normal bold 26px/53px Montserrat;
                letter-spacing: 0px;
                color: #00B09E;
                opacity: 1;">Mantenedor Reglamento por Jardín</p>
        </div>
        
       <table>
        <tr>
            <td>
                <p class="table-row-title">Código Jardín</p>
            </td>
            <td>
                <input style="width: 230px; "type="text" id="codigoJardin" [(ngModel)]="codigoJardinRBD">
            </td>
            <td>
                <button type="button" (click)="obtenerjardin()"  class="btn btn-light btn-send" >BUSCAR</button>
            </td>
        </tr>
    </table>

    <div *ngIf="busquedaOK">
        <p class="titulo-card-amarillo">Datos del Jardín Infantil</p>

                    <table class="table-info">
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Código:</p>
                            </td>
                            <td>{{dataJardin.rbd}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Nombre:</p>
                            </td>
                            <td>{{dataJardin.jardin}}</td>
                        </tr>
                        <tr class="table-tr-shadow">
                            <td>
                                <p class="table-row-title">Estado Reglamento Interno:</p>
                            </td>
                            <td>{{dataJardin.estadoRI}}</td>
                        </tr>
                    </table>
        <div *ngIf="dataJardin.estadoRI !== 'Iniciado'">  
         <p class="titulo-card-amarillo">Activar Plan Educativo para edición</p>

            <table>
                <tr>
                    <td>
                        <button type="button" (click)="activarRIIndividual()"  class="btn btn-light btn-send" >ACTIVAR</button>
                    </td>
                </tr>
            </table>
        </div>
    </div>
    
    </div>
  
</div>